export default "__VITE_ASSET__0f590b75__"